var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prototype-attribute-table',{attrs:{"attribute-name":"fabric"}})
}
var staticRenderFns = []

export { render, staticRenderFns }